import { Box, Typography } from '@mui/material'
import { Dialog } from 'elements/feedback'
import { useBoolean } from 'lib/hooks'
import { Trans } from 'react-i18next'

import { ContactUsForm } from './contact-us-form'

export const UpgradePlanMessage = () => {
  const isOpen = useBoolean(false)

  return (
    <>
      <Typography
        height={24}
        display="block"
        variant="caption3"
        bgcolor="primary.light"
        width="100%"
        textAlign="center"
        fontWeight={600}
        color="text.primary"
      >
        <Trans
          i18nKey="contact_us.please_contact_us_to_get_full_access"
          components={{
            button: (
              <Box
                onClick={isOpen.setTrue}
                display="inline-block"
                sx={{
                  color: 'inherit',
                  textDecoration: 'underline',
                  textUnderlineOffset: '2px',
                  cursor: 'pointer',
                }}
              />
            ),
          }}
        />
      </Typography>

      <Dialog open={isOpen.isTrue} onClose={isOpen.setFalse}>
        <ContactUsForm onClose={isOpen.setFalse} />
      </Dialog>
    </>
  )
}
